import { Modal } from 'antd';

import type { MessageModalProps } from '@app/pages/SalesFunnels/LogsRegistry/types';

import type { FC } from 'react';

export const MessageModal: FC<MessageModalProps> = ({
  open,
  handleModalClose,
  messageText,
}) => {
  return (
    <Modal
      open={open}
      title="Просмотр сообщения"
      onCancel={handleModalClose}
      okButtonProps={{
        className: 'hidden-ok-button',
      }}
      footer={<></>}
    >
      {messageText}
    </Modal>
  );
};
